export const mountainwaves = [
	{
		"id": 1,
		"jump": "waves1",
		"title": "Mountain Waves I",
		"pic": "../img/mountain/waves1.jpg",
		"alt": "Mountain Waves 1, Digital Photo Series",
		"left": "imagewider",
		"right": "slimmer",
		"orientation": "landscape"
	},
	{
		"id": 2,
		"jump": "waves2",
		"title": "Mountain Waves II",
		"pic": "../img/mountain/waves2.jpg",
		"alt": "Mountain Waves 2, Digital Photo Series",
		"left": "imagewider",
		"right": "slimmer",
		"orientation": "landscape"
	},
	{
		"id": 3,
		"jump": "waves3",
		"title": "Mountain Waves III",
		"pic": "../img/mountain/waves3.jpg",
		"alt": "Mountain Waves 3, Digital Photo Series",
		"left": "imagewider",
		"right": "slimmer",
		"orientation": "landscape"
	},
	{
		"id": 4,
		"jump": "waves4",
		"title": "Mountain Waves IV",
		"pic": "../img/mountain/waves4.jpg",
		"alt": "Mountain Waves 4, Digital Photo Series",
		"left": "imagewider",
		"right": "slimmer",
		"orientation": "landscape"
	},
]